import { useEffect, useState } from 'react';
import { withCurrentSearch } from '@utils/websiteUrlUtils';

/**
 * Bare href on the server and the first client render, then the current
 * search merged in after mount so hydration matches.
 */
export const useOutboundHref = (
  url: string | undefined,
  preserveSearch = true
): string | undefined => {
  const [href, setHref] = useState(url);

  useEffect(() => {
    if (!url) {
      setHref(undefined);
      return;
    }
    setHref(preserveSearch ? withCurrentSearch(url) : url);
  }, [url, preserveSearch]);

  return href;
};
